import React, { useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import SearchIcon from 'assets/icons/search-icon'
import ClearIcon from 'assets/icons/clear-icon'
import TooltipComponent from '../Tooltip'

import {
  SearchClearIconWrapper,
  SearchInputContainer,
  SearchInputIconWrapper,
  StyledSearchInput,
  SearchIconWrapper
} from './style'

const tooltipXOffset = 0
const tooltipYOffset = 16
const SearchInput = ({ placeholder, onChange, value, type, height = '40px', dataTest }) => {
  const [isOpenSearch, setIsOpenSearch] = useState(true)
  const searchRef = useRef()

  function handleClear() {
    onChange({ target: { value: '' } })
  }

  function openSearchBar() {
    setIsOpenSearch(true)
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }} ref={searchRef}>
      {isOpenSearch ? (
        <SearchInputContainer>
          <SearchInputIconWrapper>
            <SearchIcon />
          </SearchInputIconWrapper>
          <FormattedMessage id={placeholder}>
            {(placeHolder) => {
              return (
                <StyledSearchInput
                  placeholder={placeHolder}
                  height={height}
                  onChange={onChange}
                  value={value}
                  type={type}
                  data-test={dataTest}
                  autoFocus={true}
                />
              )
            }}
          </FormattedMessage>
          {value && (
            <SearchClearIconWrapper onClick={handleClear}>
              <ClearIcon />
            </SearchClearIconWrapper>
          )}
        </SearchInputContainer>
      ) : (
        <TooltipComponent
          style={{ zIndex: 10000 }}
          placement="bottom"
          trigger={['hover']}
          align={{ offset: [tooltipXOffset, tooltipYOffset] }}
          overlay={{ label: 'search' }}
        >
          <SearchIconWrapper data-test="search-icon" onClick={openSearchBar}>
            <SearchIcon />
          </SearchIconWrapper>
        </TooltipComponent>
      )}
    </div>
  )
}

export default SearchInput
